import React from 'react';

const UnorderedListIcon = props => (
  <svg viewBox="0 0 16 14" style={{ fillRule: 'evenodd' }} {...props}>
    <path
      stroke="none"
      d="M253,90h12v2H253V90Zm-4,0h2v2h-2V90Zm4,4h12v2H253V94Zm-4,0h2v2h-2V94Zm4,4h12v2H253V98Zm-4,0h2v2h-2V98Zm4,4h12v2H253v-2Zm-4,0h2v2h-2v-2Z"
      transform="translate(-249 -90)"
    />
  </svg>
);

export default UnorderedListIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/unordered-list-icon.js